import React from 'react';
import { Scene, Shell } from '../../components/ui';
import VoiceInvitation from './VoiceInvitation';
import './VoiceInvitation.css';

/**
 * Accountless donor surface: the night scene, a brand-only header, and one
 * narrow content column. No navigation and no player are ever mounted here.
 */
const AccountlessDonorApp: React.FC = () => (
  <Scene>
    <Shell mode="donor">
      <div className="donor-page">
        <VoiceInvitation />
        <p className="donor-page__privacy">This private page is limited to one voice invitation.</p>
      </div>
    </Shell>
  </Scene>
);

export default AccountlessDonorApp;
